/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Router, createRouter } from 'router5';
import browserPluginFactory from 'router5-plugin-browser';
import { routes, RouteId } from './routes';

export function configureRouter(): Router {
    const defaultRoute =
        process.env.REACT_APP_API_PREFIX && process.env.REACT_APP_API_PREFIX === 'pks-inspector'
            ? RouteId.InspectorLogin
            : RouteId.Main;

    const router = createRouter(routes, {
        defaultRoute: defaultRoute,
    });

    router.usePlugin(browserPluginFactory({ useHash: true }));

    return router;
}
